export const shipmentOptions = [
  {
    id: 1,
    title: 'Book a Delivery',
    description: 'Send out a parcel, locally or internationally',
    value: 'Export'
  },
  {
    id: 2,
    title: 'Book an Import',
    description: 'Receive a package from anywhere in the world',
    value: 'Import'
  },
  {
    id: 3,
    title: 'Shop & ship',
    description: 'Shop & ship to our US, UK or Canada addresses',
    value: 'ShopNShip'
  }
];

export const shipmentMethods = [
  {
    id: 1,
    title: 'Drop Off',
    description: 'Drop off your items at the nearest Topship processing center',
    dropoff: 'Free',
    value: 'DropOff',
    amount: 0
  },
  {
    id: 2,
    title: 'Request a Pickup',
    description: `A dispatch rider will pick up your items at your preferred location.`,
    pickup: '',
    value: 'PickUp',
    amount: 0
  }
];

export const shipmentDestinationTypes = [
  {
    id: 1,
    title: ' Single Destination',
    description: 'Send your items to only one destination.',
    value: 'Single'
  },
  {
    id: 2,
    title: 'Multiple Destinations',
    description: (
      <>
        <p>Send items to multiple destinations.</p>
        <br />
        <p className='text-danger'>
          <b>Maximum limit of 4 receivers per booking</b>
        </p>
      </>
    ),
    value: 'Multiple'
  }
];

export const bookImportTypes = [
  {
    id: 1,
    title: 'Worldwide Imports',
    description: 'Import from any city in the world'
  },
  {
    id: 2,
    title: 'China Imports',
    description: 'Ship from suppliers and manufacturers in China'
  }
];

export const shipmentHubs = [
  // {
  //   title: 'Abuja Hub',
  //   description: 'Undergoing hub upgrade (available for pick-ups only)',
  //   // description: '5, Asa street, off Gana Street, Maitama',
  //   slug: 'abuja',
  //   value: {
  //     addressLine1: '5, Asa street, off Gana Street',
  //     addressLine2: 'Maitama',
  //     country: 'Nigeria',
  //     countryCode: 'NG',
  //     state: 'Abuja',
  //     city: 'Maitama'
  //   }
  // },
  {
    title: 'Lagos Island Hub',
    description: '25B Bisola Durosinmi Etti Drive Lekki Phase 1',
    slug: 'lagos-island',
    value: {
      addressLine1: '25B Bisola Durosinmi Etti Drive',
      addressLine2: 'Lekki Phase 1',
      country: 'Nigeria',
      countryCode: 'NG',
      state: 'Lagos',
      city: 'Lekki Phase 1'
    }
  },
  {
    title: 'Lagos Mainland Hub',
    description: '3 Dapo Bode Thomas Street, Sabo, Yaba',
    slug: 'lagos-mainland',
    value: {
      addressLine1: '3 Dapo Bode Thomas Street',
      addressLine2: 'Sabo, Yaba',
      country: 'Nigeria',
      countryCode: 'NG',
      state: 'Lagos',
      city: 'Yaba'
    }
  },
  {
    title: 'Ibadan Hub',
    description: 'Shop A24, Grand Mall, Secretariat Road, Bodija Market',
    slug: 'ibadan',
    value: {
      addressLine1: 'Shop A24, Grand Mall, Secretariat Road',
      addressLine2: 'Bodija Market',
      country: 'Nigeria',
      countryCode: 'NG',
      state: 'Oyo',
      city: 'Ibadan'
    }
  },
  {
    title: 'Port Harcourt Hub',
    description: '24 Ezegbakagbaka Road, Woji',
    slug: 'port-harcourt',
    value: {
      addressLine1: '24 Ezegbakagbaka Road, Woji',
      addressLine2: 'Woji',
      country: 'Nigeria',
      countryCode: 'NG',
      state: 'Rivers',
      city: 'Portharcourt'
    }
  }
];

export const allowedIntraCityUsers = [];

export const defaultDetail = {
  country: 'Nigeria',
  countryCode: 'ng'
};

export const flatRates = [
  '0.5kg - 2kg - ₦50,000',
  '2.1kg - 3kg - ₦55,000',
  '3.1kg - 5kg - ₦70,000',
  '5.1kg - 9.4kg - ₦107,000'
];

// Non-flat rates
export const nonFlatRates = ['10kg and above - ₦14,500/kg'];

export const EU_countries = [
  'Albania',
  'Andorra',
  'Austria',
  'Belarus',
  'Belgium',
  'Bosnia and Herzegovina',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Iceland',
  'Ireland',
  'Italy',
  'Latvia',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Moldova',
  'Monaco',
  'Montenegro',
  'Netherlands',
  'North Macedonia',
  'Norway',
  'Poland',
  'Portugal',
  'Romania',
  'San Marino',
  'Serbia',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Switzerland'
];

export const budgetRatePerCountries = [
  {
    country: '🇺🇸 United States of America',
    rates: {
      nonFlats: '9.1kg and above - ₦18,500/kg',
      flats: [
        '0.5kg - 1kg - ₦54,000',
        '1.1kg - 2kg - ₦70,000',
        '2.1kg - 3kg - ₦85,000',
        '3.1kg - 4kg - ₦99,000',
        '4.1kg - 5kg - ₦114,000',
        '5.1kg - 6kg - ₦128,000',
        '6.1kg - 7kg - ₦142,000',
        '7.1kg - 8kg - ₦159,000',
        '8.1kg - 9kg - ₦180,000'
      ]
    }
  },
  {
    country: '🇬🇧 United Kingdom',
    rates: {
      nonFlats: '9.1kg and above - ₦16,000/kg',
      flats: [
        '0.5kg - 1kg - ₦54,000',
        '1.1kg - 2kg - ₦61,000',
        '2.1kg - 3kg - ₦73,000',
        '3.1kg - 4kg - ₦86,000',
        '4.1kg - 5kg - ₦98,000',
        '5.1kg - 6kg - ₦109,000',
        '6.1kg - 7kg - ₦120,000',
        '7.1kg - 8kg - ₦132,000',
        '8.1kg - 9kg - ₦147,000'
      ]
    }
  },
  {
    country: '🇨🇦 Canada',
    rates: {
      nonFlats: '9.1kg and above - ₦18,500/kg',
      flats: [
        '0.5kg - 1kg - ₦54,000',
        '1.1kg - 2kg - ₦70,000',
        '2.1kg - 3kg - ₦85,000',
        '3.1kg - 4kg - ₦99,000',
        '4.1kg - 5kg - ₦114,000',
        '5.1kg - 6kg - ₦128,000',
        '6.1kg - 7kg - ₦142,000',
        '7.1kg - 8kg - ₦159,000',
        '8.1kg - 9kg - ₦180,000'
      ]
    }
  },
  {
    country: '🇪🇺 Rest of Europe',
    rates: {
      nonFlats: '10kg and above - ₦16,000/kg',
      flats: [
        '0.5kg - 1kg - ₦70,000',
        '1.1kg - 2kg - ₦83,000',
        '2.1kg - 3kg - ₦95,000',
        '3.1kg - 4kg - ₦107,000',
        '4.1kg - 5kg - ₦117,000',
        '5.1kg - 6kg - ₦130,000',
        '6.1kg - 7kg - ₦143,000',
        '7.1kg - 8kg - ₦146,000',
        '8.1kg - 9kg - ₦159,000',
        '9.1kg - 10kg - ₦165,000'
      ]
    }
  },
  {
    country: '🌍 Rest of Africa',
    rates: {
      nonFlats: '',
      flats: []
    }
  }
];
